import React from "react";

export class Pace extends React.Component {

    constructor(props) {
        super(props);
        this.startPace = this.startPace.bind(this);
        this.raisePace = this.raisePace.bind(this);
        this.pace = React.createRef();
        this.paceProgress = React.createRef();
    }

    //logika prebacena u componentDidUpdate
    // componentWillReceiveProps(nextProps) {
    //     if (this.props.showLoading != nextProps.showLoading) {  
    //         this.startPace();
    //     }
    // }

    componentDidUpdate(prevProps) {
        if (prevProps.showLoading != this.props.showLoading) {
            this.startPace();
        }
    }
    
    startPace() {
        if (this.paceProgress.current)
            this.paceProgress.current.style.transform = 'translate3d(0%, 0px, 0px)';
        setTimeout(this.raisePace, 250, 0);
    }

    raisePace(current) {
        var newValue = current + (100 - current) / 5;
        if (this.paceProgress.current)
            this.paceProgress.current.style.transform = 'translate3d(' + newValue + '%, 0px, 0px)';
        if (this.props.showLoading && newValue < 99.9)
            setTimeout(this.raisePace, 250, newValue);
    }

    render() {
        return (
            <div className={this.props.showLoading ? '' : 'pace-inactive'}>
                <div className="pace" ref={this.pace}>
                    <div className="pace-progress shadow shadow-small" ref={this.paceProgress}>
                        <div className="pace-progress-inner"></div>
                    </div>
                </div>
            </div>
        );
    }

}
